import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

const navItems = [
  { name: "首页", path: "/", icon: "ri-home-4-line" },
  { name: "漫画库", path: "/category/all", icon: "ri-book-open-line" },
  { name: "关于我们", path: "/about", icon: "ri-team-line" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [open, setOpen] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category/all?q=${encodeURIComponent(q)}` : "/category/all");
    setOpen(false);
  };

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur border-b border-background-200/70">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="漫天堂 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg" />
          </span>
          <span className="font-heading text-xl font-bold text-foreground-950">
            漫<span className="text-primary-600">天堂</span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                isActive(item.path)
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              <i className={item.icon} />
              {item.name}
            </Link>
          ))}
        </nav>

        {/* Desktop search */}
        <form
          onSubmit={handleSearch}
          className="hidden w-full max-w-xs items-center gap-2 rounded-full bg-background-100 px-3 py-2 focus-within:ring-2 focus-within:ring-primary-400 lg:flex"
          role="search"
        >
          <i className="ri-search-line text-foreground-500" />
          <input
            type="search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索漫画"
            className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            aria-label="搜索漫画"
          />
          <button type="submit" className="text-primary-600 whitespace-nowrap" aria-label="搜索">
            搜索
          </button>
        </form>

        {/* Mobile hamburger */}
        <button
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
          aria-label="打开菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={handleSearch} className="mb-3 flex items-center gap-2 rounded-full bg-background-100 px-3 py-2">
            <i className="ri-search-line text-foreground-500" />
            <input
              type="search"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </form>
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={`flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium ${
                  isActive(item.path) ? "bg-primary-100 text-primary-700" : "text-foreground-700"
                }`}
              >
                <i className={item.icon} />
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}